/* ============================================================
   CS Mobile Experience Script — v1
   CarnivalSource.com

   Exits immediately at desktop widths (>= 768px, the theme's own
   breakpoint). Desktop behavior is untouched.

   1. Sticky Add-to-Cart bar driver (product pages)
      - Reuses the Booster theme's dormant .sticky--mobile markup.
        The template's "Sticky ATC" block setting stays "disabled";
        this script drives ONLY the mobile bar.
      - Bar appears (collapsed) when the main Add to Cart button
        scrolls out of view, hides again when it scrolls back.
      - Tapping the collapsed bar expands the full panel (title,
        price, quantity, Add to Cart, Buy Now). The theme's own
        close (X) collapses it again.
   2. Footer "Links" accordion
      - Wraps each footer Links column's anchors in a collapsible
        panel with proper ARIA wiring. The Contact Us column is
        intentionally left expanded.
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_MAX = 767;
  if (window.innerWidth > MOBILE_MAX) return;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ── 1. Sticky Add-to-Cart bar ─────────────────────────────── */
  function initStickyATC() {
    var bar = document.querySelector('.sticky--mobile');
    if (!bar || bar.dataset.csInitd) return;

    // Anchor: the theme's own ATC wrapper on the PDP.
    var anchor = document.querySelector('.product__atc') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!anchor) return;

    bar.dataset.csInitd = 'true';

    // v2: reparent the bar to <body>. If any ancestor gains a transform,
    // filter, or backdrop-filter (theme animations, apps), it becomes the
    // bar's containing block and position:fixed silently breaks - iOS
    // Safari is especially prone. Direct <body> children are immune.
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    // Collapsed by default; the theme CSS shows only the open
    // button in the .sticky--closed state.
    bar.classList.add('sticky--closed');

    // The dormant open button ships with an inline onclick that
    // adds to cart immediately. Repurpose it: first tap expands
    // the panel instead.
    var openBtn = bar.querySelector('.sticky--open__button');
    if (openBtn) {
      openBtn.removeAttribute('onclick');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.addEventListener('click', function (e) {
        e.preventDefault();
        bar.classList.remove('sticky--closed');
        openBtn.setAttribute('aria-expanded', 'true');
      });
    }

    // The theme's close (X) re-collapses; keep aria in sync.
    var closeBtn = bar.querySelector('.sticky__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      });
    }

    // Show the bar when the real ATC button is off-screen.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.add('hide');
            bar.classList.add('sticky--closed');
            if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
          } else if (entry.boundingClientRect.top < 0) {
            // Only trigger once the buy box has scrolled ABOVE the
            // viewport (not while it is still below, pre-scroll).
            bar.classList.remove('hide');
          }
        });
      }, { threshold: 0 });
      io.observe(anchor);
    } else {
      // Tiny fallback for very old browsers.
      var onScroll = function () {
        var r = anchor.getBoundingClientRect();
        if (r.bottom < 0) bar.classList.remove('hide');
        else {
          bar.classList.add('hide');
          bar.classList.add('sticky--closed');
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ── 2. Footer "Links" accordion ───────────────────────────── */
  function initFooterAccordion() {
    var linkBlocks = document.querySelectorAll('.footer .footer__links');
    linkBlocks.forEach(function (block, ix) {
      if (block.dataset.csInitd) return;
      block.dataset.csInitd = 'true';

      var title = block.querySelector('.footer__title');
      var anchors = block.querySelectorAll('a');
      if (!title || anchors.length < 4) return; // short lists stay open

      // Wrap the anchors in a collapsible panel.
      var panel = document.createElement('div');
      panel.className = 'cs-accordion__panel';
      panel.id = 'cs-footer-panel-' + ix;
      anchors.forEach(function (a) { panel.appendChild(a); });
      block.appendChild(panel);

      block.classList.add('cs-accordion');
      title.classList.add('cs-accordion__toggle');
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-expanded', 'false');
      title.setAttribute('aria-controls', panel.id);

      function toggle() {
        var open = block.classList.toggle('cs-accordion--open');
        title.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      title.addEventListener('click', toggle);
      title.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  ready(function () {
    initStickyATC();
    initFooterAccordion();
  });
})();
